import { render } from "./ModalDifferences.vue?vue&type=template&id=5f615086"
import script from "./ModalDifferences.vue?vue&type=script&lang=js"
export * from "./ModalDifferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__